import { Hero } from "../components/Hero";
import Container from "@mui/material/Container";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { VideoPlayer } from "../components/VideoPlayer/VideoPlayer";
import { Section } from "../components/Section";
import { content } from "../content/content-students";
import { Trainers } from "../components/Trainers/trainers";
import { SectionContainer } from "../components/SectionContainer";
import { Calendar } from "../components/Calendar";
import { StyledMarkdown } from "../components/StyledMarkdown/StyledMarkdown";
import { InfoForm } from "../components/InfoForm";
import { PersonalMeeting } from "../components/PersonalMeeting";
import { dates } from "../content/dates";
import { Grid } from "@mui/material";
import React, { Fragment, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Footer } from "../components/Footer";
import { Teaser } from "../components/Teaser";
import { PartnerBox } from "../components/PartnerBox";
import { NewsSection } from "../components/NewsSection";
// import { CallToAction } from "../components/CallToAction";
import { Slider } from "../components/Slider";
import { Card } from "../components/Card";
import { useMediaQuery } from "@mui/material";
import { StyledAnchorLink } from "../components/StyledAnchorLink";

function Students() {
  const contactRef = useRef(null);
  const { hash } = useLocation();
  const isMobile = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    }
  }, [hash]);

  const [tabIndex, setTabIndex] = React.useState(0);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <>
      <div id="intro"></div>
      {/* <NewHero
        image="/img/key-visual-crop.jpg"
        claim={`Reboot your life`}
        options={{ backgroundPosition: "70% 30%" }}
      /> */}
      <Hero
        image="/img/cropped-key-visual-AdobeStock_358964292_3200x1730.jpg"
        opacity={0.2}
        xsTop={"200px"}
        xsRight={"40px"}
        smTop={"200px"}
        smRight={"40px"}
        mdTop={"40px"}
        mdRight={"calc(15px + 4vw)"}
        backgroundPosition={"70% 30%"}
        borderRadius={0}
      />

      <div
        style={{
          backgroundColor: "var(--secondary-color)",
          marginBottom: "20px",
        }}
      >
        {/* <Container
          sx={{
            paddingLeft: "0 !important",
            paddingRight: "0 !important",
            paddingTop: "0 !important",
            paddingBottom: "0 !important",
          }}
        >
          <Teaser teaserItems={content.teaser} />
        </Container> */}
      </div>
      {/* <div>
        <Container
          sx={{
            paddingLeft: "0 !important",
            paddingRight: "0 !important",
            paddingTop: "0 !important",
            paddingBottom: "0 !important",
          }}
        >
          <p
            style={{
              // margin: "6px 0",
              textAlign: "center",
              fontSize: "0.8em",
              color: "#00000044",
            }}
          >
            Unsere Partnerfirmen
          </p>
        </Container>

        <PartnerBox />
      </div> */}
      <Container
        sx={{
          backgroundColor: "#f3f3f3",
          borderRadius: [0, 0, 2],
          paddingTop: 4,
          paddingBottom: 4,
        }}
      >
        <NewsSection></NewsSection>
      </Container>

      <Container component="main">
        <Footer omit="students" />
      </Container>
    </>
  );
}

export default Students;
